import R from 'ramda';

const getState = (
  isOwner,
  contractBlocks,
  agreementContractBlocks,
  dealBlocks
) => {
  let state = { field1: '' };

  const contractBlock = R.find(R.propEq('name', 'Governing Law'))(
    contractBlocks
  );
  if (contractBlock) {
    state = {
      field1: contractBlock.options ? contractBlock.options.field1 : '',
      type: 'state',
    };

    let block = R.find(R.propEq('contract_block', contractBlock.id))(
      agreementContractBlocks
    );
    if (block && block.options) {
      state = JSON.parse(block.options);
    }

    if (!isOwner) {
      block = R.find(R.propEq('id', contractBlock.id))(dealBlocks);
      if (block && block.changes) {
        state = block.changes;
      }
    }
  }
  return state;
};

export default getState;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getState.js